import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { SegmentListService } from '../../service/segment-list/segment-list.service';

@Component({
	selector: 'app-segment-list',
	templateUrl: './segment-list.component.html',
	providers: [
		SegmentListService,
		HttpModule
	]
})

export class SegmentListComponent implements OnInit {
	private token;
	public segments: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Descricao";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	segment: FormGroup;

	constructor(fb: FormBuilder, private segmentListService: SegmentListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.segment = fb.group({
			'Descricao': '',
			'Ativo': 'true'
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchSegment(this.segment.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchSegment(this.segment.value, this.currentPage, false);
	}

	searchSegment(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Descricao";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.segmentListService.searchSegment(this.token, value.Descricao, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.segments = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchSegment(this.segment.value, $event, false);
	}

}





// WEBPACK FOOTER //
// ./src/app/segments/component/segment-list/segment-list.component.ts